import {
  ETAT_NOUVEAU, INTERVENTION_TYPE_NON_DEFINI, SOURCE_TELEPHONE,
} from '@/configuration/logistique/intervention/interventionConf';
import generer from '@/services/general/genererAdresse';

export default function genererDemandeIntervention() {
  return {
    agenceId: null,
    societeId: null,
    type: INTERVENTION_TYPE_NON_DEFINI,
    demandeurId: null,
    source: SOURCE_TELEPHONE,
    etat: ETAT_NOUVEAU,
    adresse: generer(),
    actionLogistique: null,
    demandeLogistiqueParentId: null,
    datePlanification: null,
    typeOtId: null,
    emplacementId: null,
    dispositifId: null,
    materielId: null,
    faceId: null,
    dateLimite: null,
    description: '',
    tags: [],
  };
}
